import React, { useState, useEffect } from 'react';
import { Table, Tag, Button, Space, Typography, message } from 'antd'; // J'ai retiré 'Text' qui n'est pas utilisé directement ici
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import axiosInstance from '../../services/axiosServicesVisit';
import dayjs from 'dayjs';

const { Title, Text } = Typography; // On extrait Text depuis Typography

const CorrectionRequestsPage = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(null);

    const fetchPendingRequests = async () => {
        setLoading(true);
        try {
            // CORRECTION DE L'URL ICI
            const response = await axiosInstance.get('/v1/data-corrections/pending/persons');
            setRequests(response.data);
        } catch (error) {
            message.error("Erreur lors du chargement des suggestions.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPendingRequests();
    }, []);

    const handleAction = async (id, action) => {
        setActionLoading(id);
        try {
            await axiosInstance.post(`/v1/data-corrections/${id}/${action}`);
            message.success(`La suggestion a été ${action === 'approve' ? 'approuvée' : 'rejetée'}.`);
            fetchPendingRequests();
        } catch (error) {
            message.error("Une erreur est survenue.");
        } finally {
            setActionLoading(null);
        }
    };
    
    const columns = [
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date) => dayjs(date).format('DD/MM/YYYY HH:mm'),
            sorter: (a, b) => dayjs(a.createdAt).unix() - dayjs(b.createdAt).unix(),
        },
        {
            title: 'Délégué',
            key: 'delegate',
            render: (_, record) => `${record.submittedBy.firstname} ${record.submittedBy.lastname}`,
        },
        {
            title: 'Médecin',
            key: 'person',
            render: (_, record) => `${record.person.firstname} ${record.person.lastname}`,
        },
        {
            title: 'Champ',
            dataIndex: 'fieldName',
            key: 'fieldName',
            render: (field) => <Tag color="blue">{field}</Tag>,
        },
        {
            title: 'Valeur Actuelle',
            key: 'currentValue',
            render: (_, record) => {
                if (record.currentValue) {
                    return record.currentValue;
                }
                if (record.fieldName === 'specialty') {
                    return record.person.doctor?.specialty?.name || <Text type="secondary">N/A</Text>;
                }
                if (record.fieldName === 'address') {
                    return record.person.address || <Text type="secondary">N/A</Text>;
                }
                if (record.fieldName === 'location') {
                    const locationString = [record.person.government?.name, record.person.region?.name].filter(Boolean).join(' - ');
                    return locationString || <Text type="secondary">N/A</Text>;
                }
                return <Text type="secondary">N/A</Text>;
            }
        },
        {
            title: 'Valeur Suggérée',
            dataIndex: 'suggestedValue',
            key: 'suggestedValue',
            render: (value) => <Text strong>{value}</Text>
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<CheckOutlined />}
                        onClick={() => handleAction(record.id, 'approve')}
                        loading={actionLoading === record.id}
                        ghost
                    >
                        Approuver
                    </Button>
                    <Button
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => handleAction(record.id, 'reject')}
                        loading={actionLoading === record.id}
                    >
                        Rejeter
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <>
            <Title level={3}>Suggestions de Correction (Médecins/etc.)</Title>
            <Table
                columns={columns}
                dataSource={requests}
                loading={loading}
                rowKey="id"
                bordered
                size="small"
                locale={{ emptyText: 'Aucune suggestion en attente.' }}
            />
        </>
    );
};

export default CorrectionRequestsPage;